import { render, staticRenderFns } from "./resource-content.vue?vue&type=template&id=1c25ebe8&scoped=true"
import script from "./resource-content.vue?vue&type=script&lang=js"
export * from "./resource-content.vue?vue&type=script&lang=js"
import style0 from "./resource-content.vue?vue&type=style&index=0&id=1c25ebe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c25ebe8",
  null
  
)

export default component.exports